import { StyleSheet } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        width: '100%',
    },
    containerFlex: {
        flex: 1,
    },
    flexDirectionRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    alignCenter: {
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerItem: {
        flex: 1,
        flexDirection: 'row',
        paddingRight: 10,
    },
    image: {
        marginLeft: 10,
        width: 80,
        height: 80,
        borderRadius: 10,
    },
    containerData: {
        flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    containerInput: {
        marginEnd: 12,
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        lineHeight: 20,
        paddingHorizontal: 15,
        //marginBottom: 'auto',
    },
    titleBis: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
        paddingHorizontal: 15,
        paddingBottom: 5,
    },
    paddinVertical: {
        paddingTop: 8,
        paddingBottom: 8,
    },
    description: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: '600',
        textAlign: 'left',
        paddingBottom: 5,
        paddingHorizontal: 15,
        marginTop: 4,
    },
    ean: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
        paddingBottom: 5,
        paddingHorizontal: 15,
        marginTop: 4,
        //marginTop: 'auto',
    },
    containerYesNo: {
        width: 24,
        height: 24,
        marginLeft: 5,
    },
    containerNa: {
        width: 58,
        height: 24,
        marginHorizontal: 3,
        marginVertical: 6,
    },
    imageYesNo: {
        width: 24,
        height: 24,
        aspectRatio: 1,
    },
    imageNa: {
        width: 58,
        height: 24,
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    containerButton: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerMiniButton: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 15,
    },
    containerMiniButtonBisSelected: {
        flexDirection: 'row',
        width: 98,
        //height: 34,
        borderWidth: 2,
        borderRadius: 8,
        borderColor: theme.colors.darkGray,
        backgroundColor: theme.colors.darkGray,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginVertical: 4,
        paddingVertical: 4,
        paddingHorizontal: 4,
    },
    containerMiniButtonBisUnselected: {
        flexDirection: 'row',
        width: 98,
        //height: 34,
        borderWidth: 2,
        borderRadius: 8,
        borderColor: theme.colors.darkGray,
        backgroundColor: 'transparent',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginVertical: 4,
        paddingVertical: 4,
        paddingHorizontal: 4,
    },
    textButtonNASelected: {
        fontSize: 11,
        fontWeight: 'bold',
        color: 'white',
        marginHorizontal: 2,
    },
    textButtonNAUnselected: {
        fontSize: 11,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
        marginHorizontal: 2,
    },
    textButtonNASelectedBis: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        marginHorizontal: 2,
    },
    textButtonNAUnselectedBis: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
        marginHorizontal: 2,
    },
    textButtonNASelected: {
        fontSize: 11,
        fontWeight: 'bold',
        color: 'white',
        marginHorizontal: 2,
    },
    textButtonNAUnselected: {
        fontSize: 11,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
        marginHorizontal: 2,
    },
    containerButtonPick: {
        flexDirection: 'row',
        width: 72,
        borderWidth: 2,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginVertical: 4,
        paddingVertical: 4,
        paddingHorizontal: 4,
        backgroundColor: theme.colors.colorPrimary,
    },
    textButtonPick: {
        fontSize: 11,
        fontWeight: 'bold',
        color: 'white',
    },
    textMiniButton: {
        fontSize: 11,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
    },
    textButtonNA: {
        fontSize: 11,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
        marginHorizontal: 2,
    },
    marginLeft: {
        marginLeft: 4,
    },
    input: {
        width: 98,
        height: 34,
        borderRadius: 5,
        paddingVertical: 4,
        paddingHorizontal: 10,
        marginLeft: 0,
        marginBottom: 5,
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        verticalAlign: 'middle',
        backgroundColor: theme.colors.inputBackground,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    spacer: {
        height: 10,
    },
    text: {
        fontSize: 24,
        fontWeight: 'normal',
        paddingBottom: 4,
        color: theme.colors.textPrimary,
    },
})

export default styles
